class ComponentHelper {
    static createStateErrorsObject(state: any): any {
        return Object.keys(state).reduce((acc, key) => Object.assign(acc, {[key]: undefined}), {});
    }
}

export default ComponentHelper;
